// extracted by mini-css-extract-plugin
export var close = "Accordion-module--close--6e9a2";
export var collapser = "Accordion-module--collapser--b0247";
export var copy = "Accordion-module--copy--d1dea";
export var evergreenDeep = "Accordion-module--evergreen-deep--e03fb";
export var flip = "Accordion-module--flip--820cd";
export var numbered = "Accordion-module--numbered--f0225";
export var open = "Accordion-module--open--e8608";
export var section = "Accordion-module--section--08468";
export var toggle = "Accordion-module--toggle--223ab";
export var wrap = "Accordion-module--wrap--f1eba";